<template>
  <v-container>
    <v-toolbar>
          <v-toolbar-title>Select Fax Number</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text v-on:click="gotoNext()">
            Next
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-toolbar>
        <br>
    <v-card>
      <v-card-text>
        <v-text-field
              v-model="areaCode"
              label="Choose your area code"
              v-mask="faxMask"
              v-on:keyup="getNumbers"
        ></v-text-field>
      </v-card-text>
    </v-card>
    <br>
    <v-row>
     <v-col>
     
     </v-col>
         
    </v-row>

    
    <v-data-table
      v-if="availableNumbers.length>0"
      :headers="headers"
      :items="availableNumbers"
      item-key="serialno"
      class="elevation-1"
      hide-default-footer
    >
    <template v-slot:item.choose="{ item }">
      <v-spacer></v-spacer>
      <v-btn
      @click="chooseNumber(item)"
    >
      Choose
    </v-btn>
    </template>
  </v-data-table>
  </v-container>

  
</template>

<script>

  import {mask} from 'vue-the-mask';

  import gql from 'graphql-tag'; 
  
  const getAvailableNumbersQry = gql`
    query availableNumbers($areaCode: String) {
      availableNumbers(areaCode: $areaCode) {
        inventory_id
        serialno
        product_id
      }
    }
  `;

  import SignupMixin from '../mixins/SignupMixin.vue'

  export default {
    name: 'SignupFaxNumber',
    directives: {
      mask
    },
    mixins: [SignupMixin],
    computed: {
  
    },
    data: () => ({
      packages: [
        {text: 'Wolfhound', value: 'wolfhound'},
        {text: 'Beagle', value: 'beagle'},
      ],
      areaCode: '647',
      faxMask: '###',
      availableNumbers: [],
      headers: [
          {
            text: 'Number',
            align: 'left',
            sortable: false,
            value: 'serialno',
          },
          {
            text: ``,
            align: 'right',
            sortable: true,
            value: 'choose',
          },
       ],
    }),
    methods: {
      getNumbers: function() {
        let self = this;
        return new Promise(function(resolve,reject) {  
          if (self.areaCode.length==3) {  
            let variables = {
              areaCode:  self.areaCode,
            };
            self.$global.apolloClient.query({query: getAvailableNumbersQry, variables, fetchPolicy: 'network-only'})
            .then( function(result) {
              if (result.data.availableNumbers) {
                self.availableNumbers = result.data.availableNumbers;
              }
              console.log(self.availableNumbers);
              return resolve(self.availableNumbers);
            });
          } else {
            self.availableNumbers = [];
            return resolve(null);
          }
        });     
      },
      chooseNumber(inventory) {
        this.selectedNumber = inventory.serialno;
        this.gotoNext();
      },
      gotoNext() {
        this.$emit('gotoNext');
      }
    },
    beforeMount() {
      this.getNumbers();
    },
    watch: {

    },
    filters: {

    },
  }
</script>
